import { Layout } from 'antd'
import * as React from 'react'
import * as styles from './FixedHeaderLayout.module.less'

const { Content } = Layout

export interface FixedHeaderLayoutProps {
    content: React.ReactNode
    header: React.ReactNode
}

export const FixedHeaderLayout: React.FC<FixedHeaderLayoutProps> = (props) => {
    const { content, header } = props
    return (
        <Layout className={`${styles.fixedHeaderLayout} fixedHeaderLayout`}>
            <div className={`${styles.headerWrapper} headerWrapper`}>
                {header}
            </div>
            <Content>
                <div className={`${styles.contentWrapper} contentWrapper`}>
                    <div className={`${styles.contentPadding} contentPadding`}>
                        {content}
                    </div>
                </div>
            </Content>
        </Layout>
    )
}
